import { render } from "./ProductCategory.vue?vue&type=template&id=bb468ba8&scoped=true&ts=true"
import script from "./ProductCategory.vue?vue&type=script&lang=ts"
export * from "./ProductCategory.vue?vue&type=script&lang=ts"

import "./ProductCategory.vue?vue&type=style&index=0&id=bb468ba8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb468ba8"]])

export default __exports__